module.exports = __webpack_public_path__ + "th.9aae6ecaaf06018f738b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/th.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/th.svg
// module chunks = styles